import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const ReaderContainer = styled(Box, {})({
  position: 'relative',

  display: 'flex',
  marginTop: 20,
  marginBottom: 10,
  padding: '20px 10px 10px',
  width: '75vw',
  maxWidth: 350,

  flexDirection: 'column',
  justifyContent: 'space-between',

  background: theme.palette.white,
  borderRadius: '0 0 15px 15px',
  boxShadow: `3px 3px 10px ${theme.palette.midgrey}`,

  '& .MuiAvatar-root': { // = image
    position: 'absolute',
    top: -20,
    left: 20,

    width: 90,
    height: 90,

    borderRadius: '50%',

    aspectRatio: '1 / 1',
    objectFit: 'contain',
    objectPosition: 'center center',
  },

  '& .headline': {
    padding: '5px 20px 0',

    fontSize: 14,
  },

  '& .text': {
    ...theme.typography.pSmall,
    marginBottom: 10,
    padding: '0 20px',
  },

  '& .readerName, & .readerLocation': {
    paddingRight: 20,
    paddingLeft: 120,

    textAlign: 'right',
  },

  '&:nth-of-type(even)': {
    '& .readerName, & .readerLocation': {
      paddingRight: 120,
      paddingLeft: 20,

      textAlign: 'left',
    },

    '& .MuiAvatar-root': {
      right: 20,
      left: 'unset',
    },
  },

  '&:last-of-type': {
    marginBottom: 100,
  },

  [theme.breakpoints.up('tablet')]: {
    '&:nth-last-of-type(-n+2)': {
      marginBottom: 100,
    },
  },

  [theme.breakpoints.up('laptop')]: {
    marginTop: 108,
    marginBottom: 'unset',
    padding: '87px 30px 36px',
    width: '25%',

    boxShadow: `2px 2px 7px ${theme.palette.midgrey}`,

    textAlign: 'center',

    transition: 'box-shadow 250ms ease-in-out, transform 250ms ease-in-out',

    '&:nth-last-of-type(-n+2)': {
      marginBottom: 'unset',
    },

    '&:hover': {
      boxShadow: `3px 3px 10px ${theme.palette.midgrey}`,

      transform: 'scale(1.01)',

      transition: 'box-shadow 250ms ease-in-out, transform 250ms ease-in-out',
    },

    '& .MuiAvatar-root': { // = image
      top: -60,
      left: '50%',

      width: 121,
      height: 121,

      transform: 'translate3d(-50%, 0, 0)',
    },

    '&:nth-of-type(even)': {
      '& .MuiAvatar-root': {
        right: 'unset',
        left: '50%',
      },
    },

    '&:last-of-type': {
      marginBottom: 0,
    },
  },
});
